import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import CopyrightOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('copyright', {
  template: require('./template.html'),
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    profile() {
      return this._dropletType(this.droplet);
    },
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzCopyright' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        perspective: null,
        'box-shadow': null,
        'text-shadow': null,
        'font-size': null,
        'letter-spacing': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  name: 'copyright',
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    CopyrightOptions,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzCopyright',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
  },
  mounted() {
    this.callCssGenerator();
    this.observeVisibility();
    this.bindPlugin();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    bindPlugin() {
      const $droplet = $(this.$refs.copyright);
      $droplet.drzCopyright();
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/copyright/index.js